import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface PremiumItemProps {
  label: string;
  title: string;
  tag: string;
  copy: string[];
  bigLine: string;
  smallNote?: string | string[];
  imageLabel: string;
  reverse?: boolean;
}
export function PremiumItem({
  label,
  title,
  tag,
  copy,
  bigLine,
  smallNote,
  imageLabel,
  reverse = false
}: PremiumItemProps) {
  const noteLines = typeof smallNote === 'string' ? [smallNote] : smallNote;
  return <section className="bg-mp-dark py-20 md:py-24" data-id="element-214" data-mp="3mr2wopz4dn4g">
      <Container data-id="element-215" data-mp="3mqa1mm9iwm25">
        <div className={`flex flex-col gap-10 md:gap-14 ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center`} data-id="element-216" data-mp="3mpruuvp8ipfz">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut
        }} className="w-full md:w-[46%]" data-id="element-217" data-mp="120udjz1ovbg7">
            <PlaceholderMockup label={imageLabel} aspect="aspect-[4/3]" className="border-mp-electric/40" data-id="element-218" data-mp="2et39z8xkk44a" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut,
          delay: 0.05
        }} className="w-full md:w-[54%]" data-id="element-219" data-mp="2nreviwjkwbpv">
            <SectionTag tone="blue" data-id="element-220" data-mp="202chrzs2f30n">{label}</SectionTag>
            <h3 className="mt-4 font-heading text-2xl uppercase leading-snug text-mp-white sm:text-3xl" data-id="element-221" data-mp="200jbwmpa0mtp">{title}</h3>
            <p className="mt-1 font-heading text-xs uppercase tracking-[0.18em] text-mp-lime" data-id="element-222" data-mp="24uvwj02ho471">{tag}</p>

            <div className="mt-4 max-w-[560px] space-y-3 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-223" data-mp="17bc93bishb2n">
              {copy.map((p, idx) => <p key={idx} data-id="element-224" data-mp="2fmdu8hv099fn" data-mpi={idx}>{p}</p>)}
            </div>

            <p className="mt-6 font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl" data-id="element-225" data-mp="2aokp7s5fulgy">{bigLine}</p>

            {noteLines && <div className="mt-3 space-y-1 text-sm text-mp-gray" data-id="element-226" data-mp="2of7opmj0wfe3">
                {noteLines.map((line, idx) => <p key={idx} data-id="element-227" data-mp="2kg8nabwi30re" data-mpi={idx}>{line}</p>)}
              </div>}
          </motion.div>
        </div>
      </Container>
    </section>;
}